import { Col, Row, Modal, Form, Button } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import AdnAutoComplete from "../common/adnAutoComplete/AdnAutoComplete";
import AdnCard from "../common/adnCard/AdnCard";
import AdnDropdown from "../common/adnDropdown/AdnDropdown";
import AdnMonthYearDropdown from "../common/adnMonthYearDropdown/AdnMonthYearDropdown";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnTable from "../common/adnTable/AdnTable";
import AdnInput from "../common/adnInput/AdnInput";
import "./EmployeeFollowUpEventListForm.css";
import moment from "moment";
import { AppRoutes } from "../../AppRoutes";
import { Link } from "react-router-dom";

export const EmployeeFollowUpEventListForm = ({
  title,
  currPage,
  totalRecords,
  handleChangePage,
  handleOrderList,
  employeeFollowUpEvents,
  columns,
  employeePlaceholder,
  handleSearchEmployee,
  handleSelectEmployee,
  doneByPlaceholder,
  handleSearchDoneBy,
  handleSelectDoneBy,
  employeeList,
  doneByList,
  handleEventType,
  meetingStatusOptions,
  meetingStatusChange,
  loading,
  handleMonthChange,
  handleYearChange,
  searchDoneBy,
  done,
  month,
  year,
  employees,
  expandedRowRender,
  rowExpandable,
  handleGenerateExcel,
  excelLoading,
  followUpEventList,
  cancelEventForm,
  cancelEventVisible,
  setCancelEventVisible,
  handleCancelEventFinish,
  unresolvedModalVisible,
  setUnresolvedModalVisible,
  unresolvedEmployee,
  confirmAssignPerson,
  eventEmployeeId,
  eventAssignedToId,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Row
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <AdnPageTitle title={title} />
      </Row>
      <AdnCard loading={loading}>
        <Row gutter={16}>
          <Col
            className="filter-item"
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 6 }}
            xxl={{ span: 5 }}
          >
            <AdnAutoComplete
              placeholder={employeePlaceholder}
              handleSearch={handleSearchEmployee}
              handleSelect={handleSelectEmployee}
              resultList={employeeList}
              valueId="employeeName"
            />
          </Col>
          <Col
            className="filter-item"
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 6 }}
            xxl={{ span: 5 }}
          >
            <AdnAutoComplete
              defaultValue={searchDoneBy}
              placeholder={doneByPlaceholder}
              handleSearch={handleSearchDoneBy}
              handleSelect={handleSelectDoneBy}
              resultList={doneByList}
              valueId="id"
            />
          </Col>
          <Col
            className="filter-item"
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 6 }}
            xxl={{ span: 5 }}
          >
            <AdnDropdown
              placeholder={t(
                "manageEmployeeFollowUpEventList.placeholders.type"
              )}
              options={followUpEventList}
              handleChange={(id) =>
                handleEventType(
                  followUpEventList.find((type) => type.id === id)?.name
                )
              }
              allowClear
            />
          </Col>
          <Col
            className="filter-item"
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 6 }}
            xxl={{ span: 3 }}
          >
            <AdnDropdown
              placeholder={t(
                "manageEmployeeFollowUpEventList.placeholders.status"
              )}
              defaultValue={done}
              options={meetingStatusOptions}
              handleChange={meetingStatusChange}
              allowClear
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 12 }}
            xl={{ span: 12 }}
            xxl={{ span: 6 }}
          >
            <AdnMonthYearDropdown
              allowMonthClear
              allowYearClear
              defaultMonthValue={month != "" ? month : null}
              defaultYearValue={year != "" ? year : null}
              handleMonthChange={handleMonthChange}
              handleYearChange={handleYearChange}
            />
          </Col>
        </Row>
        <Row>
          {/* <Button
            className="ant-btn-upl"
            icon={<FileExcelOutlined />}
            style={{ marginTop: 25 }}
            type="secondary"
            onClick={handleGenerateExcel}
            loading={excelLoading}
          >
            Generate Annual Report
          </Button> */}
        </Row>
        <Row>
          <Col span={24}>
            <AdnTable
              columns={columns}
              data={employees}
              currentPage={currPage}
              totalRecords={totalRecords}
              handleChange={handleOrderList}
              handleChangePage={handleChangePage}
              expandable={expandedRowRender}
              rowExpandable={rowExpandable}
              rowClassName={(record, index) =>
                moment(record.referenceDate).add(30, "d") < moment(moment()) &&
                (record.status === 0 || record.status === 1)
                  ? "lateEventRow"
                  : ""
              }
            />
            <Modal
              title={t(
                "manageEmployeeFollowUpEventList.modals.cancelFollowUpEvent"
              )}
              open={cancelEventVisible}
              onOk={cancelEventForm.submit}
              onCancel={() => {
                cancelEventForm.resetFields();
                setCancelEventVisible(false);
              }}
              footer={[
                <Button
                  className="adn-outlined-button"
                  key="back"
                  onClick={() => setCancelEventVisible(false)}
                >
                  {t("manageEmployeeFollowUpEventList.buttons.back")}
                </Button>,
                <Button
                  key="ok"
                  type="primary"
                  onClick={cancelEventForm.submit}
                  className="adn-primary-button primary-cancel"
                >
                  <span>
                    {t("manageEmployeeFollowUpEventList.buttons.cancelEvent")}
                  </span>
                </Button>,
              ]}
            >
              <Form
                form={cancelEventForm}
                name="form_in_modal"
                layout="vertical"
                onFinish={handleCancelEventFinish}
              >
                <p>
                  {" "}
                  {t(
                    "manageEmployeeFollowUpEventList.confirmations.cancelEvent"
                  )}{" "}
                </p>
                <p>
                  {" "}
                  {t(
                    "manageEmployeeFollowUpEventList.confirmations.cancelEventNotes"
                  )}{" "}
                </p>
                <AdnInput
                  name={"note"}
                  placeholder={t(
                    "manageEmployeeFollowUpEventList.placeholders.insertNotes"
                  )}
                  maxLength={500}
                  rules={[
                    {
                      required: true,
                      message: t(
                        "manageEmployeeFollowUpEventList.validation.fieldRequired"
                      ),
                    },
                  ]}
                />
              </Form>
            </Modal>
            <Modal
              title={t(
                "manageEmployeeFollowUpEventList.modals.undoneFollowUpEvents"
              )}
              open={unresolvedModalVisible}
              onOk={() => {
                confirmAssignPerson(eventEmployeeId, eventAssignedToId);
                setUnresolvedModalVisible(false);
              }}
              okText={t("manageEmployeeFollowUpEventList.buttons.yes")}
              onCancel={() => {
                setUnresolvedModalVisible(false);
              }}
              cancelText={t("manageEmployeeFollowUpEventList.buttons.no")}
            >
              {t("manageEmployeeFollowUpEventList.modals.previousUndoneEvents")}
              <br></br>
              <Link
                to={AppRoutes.consultantById.createPath(
                  unresolvedEmployee.employeeId
                )}
              >
                {unresolvedEmployee.employeeName}
              </Link>
              <br />
              <br />
              <u>{t("manageEmployeeFollowUpEventList.labels.listOfEvents")}</u>
              <br />
              {unresolvedEmployee.listOfEvents &&
                unresolvedEmployee.listOfEvents.map((name) => {
                  return (
                    <>
                      <span>{name}</span>
                      <br />
                    </>
                  );
                })}
              <br />
              <u>
                {t(
                  "manageEmployeeFollowUpEventList.confirmations.assignEventAnyway"
                )}
              </u>
            </Modal>
          </Col>
        </Row>
      </AdnCard>
    </>
  );
};
